import React from "react";
import InvoicesPrint from "../AFReadyDisigen/InvoicesPrint";
export default function RevInvCompany(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={2} />
        </div>
    );
}

